import React, { useState } from 'react';
import { TreeItem } from '@mui/x-tree-view/TreeItem';
import { SimpleTreeView } from '@mui/x-tree-view/SimpleTreeView';
import { TreeItemData } from '../../common/CommonTypes';

export type CollapsibleComponentProps = {
  contents: TreeItemData[];
};

const CollapsibleComponent = ({
  contents
}: CollapsibleComponentProps): JSX.Element => {
  const [expandedItems, setExpandedItems] = useState<string[]>([]);

  const getTreeItemsFromData = (treeItems: TreeItemData[]) => {
    return treeItems.map((treeItemData) => {
      let children = undefined;
      if (treeItemData.children && treeItemData.children.length > 0) {
        children = getTreeItemsFromData(treeItemData.children);
      }

      return (
        <TreeItem
          key={treeItemData.id}
          itemId={treeItemData.id}
          label={treeItemData.name}
          children={children}
        />
      );
    });
  };

  const handleExpandedItemsChange = (
    event: React.SyntheticEvent,
    itemIds: string[]
  ) => {
    setExpandedItems(itemIds);
  };

  return (
    <SimpleTreeView
      expandedItems={expandedItems}
      onExpandedItemsChange={handleExpandedItemsChange}>
      {getTreeItemsFromData(contents)}
    </SimpleTreeView>
  );
};

export default CollapsibleComponent;
